export const COLORS = [
  '#378EBD',
  '#9BC6DE',
  '#CDE2EE',
  '#D4D4D4',
  '#F4CCCF',
  '#E9999F',
  '#D3343F'
]
export const PROPS_NO_DATA = ['name', 'namede', 'namefr', 'code', 'rank']

export const PROP_ORDER = [
  'excessmort',

  'vacc',
  'tests',
  'sequenced',
  'gdp',
  'stringency',
  'schools'
]

export const CHAPTER_DE: {
  [key: string]: { title: string; anno: [string, number][] }
} = {
  gdp: {
    title: '5. Auswirkungen auf die Wirtschaft',
    anno: [
      ['CH', 1],
      ['ES', 1]
    ]
  },
  tests: {
    title: '3. Die Teststrategie',
    anno: [
      ['CH', 1],
      ['DK', 1],
      ['NL', 2]
    ]
  },
  stringency: {
    title: '6. Einschränkung für die Gesellschaft',
    anno: [
      ['CH', 1],
      ['IT', 1]
    ]
  },
  excessmort: {
    title: '1. Die Übersterblichkeit',
    anno: [
      ['CH', 1],
      ['ES', 2],
      ['DK', 1]
    ]
  },
  vacc: {
    title: '2. Die Impfstrategie',
    anno: [
      ['CH', 1],
      ['GB', 1],
      ['SE', 2]
    ]
  },
  schools: {
    title: '7. Schulschliessungen',
    anno: [
      ['CH', 1],
      ['IT', 1]
    ]
  },
  sequenced: {
    title: '4. Der Beitrag zur Wissenschaft',
    anno: [
      ['CH', 1],
      ['DK', 1],
      ['ES', 2]
    ]
  }
}

export const CHAPTER_FR: {
  [key: string]: { title: string; anno: [string, number][] }
} = {
  gdp: {
    title: '5. La résilience de l’économie',
    anno: [
      ['CH', 1],
      ['ES', 1]
    ]
  },
  tests: {
    title: '3. La stratégie de tests',
    anno: [
      ['CH', 1],
      ['DK', 1],
      ['NL', 2]
    ]
  },
  stringency: {
    title: '6. Libertés individuelles',
    anno: [
      ['CH', 1],
      ['IT', 1]
    ]
  },
  excessmort: {
    title: '1. La surmortalité',
    anno: [
      ['CH', 1],
      ['ES', 1],
      ['DK', 1]
    ]
  },
  vacc: {
    title: '2. La campagne de vaccination',
    anno: [
      ['CH', 1],
      ['GB', 1],
      ['SE', 2]
    ]
  },
  schools: {
    title: '7. Le fonctionnement des écoles',
    anno: [
      ['CH', 1],
      ['IT', 1]
    ]
  },
  sequenced: {
    title: '4. La contribution de la place scientifique',
    anno: [
      ['CH', 1],
      ['DK', 1],
      ['ES', 2]
    ]
  }
}
